import { Button, Text, Tooltip, Transition, useMatches } from "@mantine/core";
import { Wand } from "../assets";

interface HelpMeNowButtonProps {
    isLoading: boolean;
    shouldShow: boolean;
    shouldCollapseIfNeeded: boolean;
    onClick: () => void;
}

export function HelpMeNowButton({ isLoading, shouldShow, shouldCollapseIfNeeded, onClick }: HelpMeNowButtonProps) {
    const shouldCollapseButtonText = useMatches({ base: true, lg: false }) && shouldCollapseIfNeeded;
    return (
        <Transition duration={400} mounted={shouldShow} transition="slide-up" timingFunction="ease">
            {(transitionStyles) => (
                <Tooltip
                    label="Quick solve"
                    zIndex="var(--mantine-priority-higher)"
                    disabled={!shouldCollapseButtonText}
                >
                    <Button
                        color="dark.7"
                        onClick={onClick}
                        size="xs"
                        rightSection={!shouldCollapseButtonText && <Wand />}
                        disabled={isLoading}
                        style={{ ...transitionStyles, border: `0.125rem solid var(--mantine-color-primary-7)` }}
                    >
                        {shouldCollapseButtonText ? <Wand /> : <Text size="xs">Quick solve</Text>}
                    </Button>
                </Tooltip>
            )}
        </Transition>
    );
}
